import ApiRequest from '../request'

export default class ExtCoprosummary {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async get(id, params = {}) {
    try {
      const res = await this.apiRequest.get(`ext_coprosummary/${id}`, params)
      return res
    } catch (error) {
      return error.response
    }
  }
}
